import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function SplashScreen() {
  const navigate = useNavigate();
  const [animationStage, setAnimationStage] = useState('initial'); // initial, logo, bridge, complete

  useEffect(() => {
    // Sequence of animations
    const timer1 = setTimeout(() => {
      setAnimationStage('logo');
    }, 500);
    
    const timer2 = setTimeout(() => {
      setAnimationStage('bridge');
    }, 1500);
    
    const timer3 = setTimeout(() => {
      setAnimationStage('complete');
    }, 2500);
    
    const timer4 = setTimeout(() => {
      navigate('/intro');
    }, 3500);
    
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
      clearTimeout(timer4);
    };
  }, [navigate]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      backgroundColor: '#4361ee',
      color: 'white',
      textAlign: 'center',
      overflow: 'hidden',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif"
    }}>
      {/* Animated Logo */}
      <div style={{
        position: 'relative',
        width: '120px',
        height: '120px',
        marginBottom: '20px'
      }}>
        {/* Mind - animated circle */}
        <div style={{
          position: 'absolute',
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          backgroundColor: '#4cc9f0',
          top: '20px',
          left: '20px',
          opacity: animationStage === 'initial' ? 0 : 1,
          transform: animationStage === 'logo' ? 'scale(1)' : 
                    animationStage === 'bridge' ? 'scale(1.2)' : 
                    animationStage === 'complete' ? 'scale(0)' : 'scale(0)',
          transition: 'all 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 0 20px rgba(76, 201, 240, 0.5)'
        }}>
          <div style={{
            fontSize: '24px',
            fontWeight: '700',
            color: 'white'
          }}>
            M
          </div>
        </div>
        
        {/* Bridge - animated rectangle */}
        <div style={{
          position: 'absolute',
          width: '100px',
          height: '20px',
          backgroundColor: '#f72585',
          top: '50px',
          left: '10px',
          opacity: animationStage === 'logo' ? 1 : 
                  animationStage === 'bridge' ? 1 : 
                  animationStage === 'complete' ? 1 : 0,
          transform: animationStage === 'logo' ? 'scaleX(0)' : 
                    animationStage === 'bridge' ? 'scaleX(1)' : 
                    animationStage === 'complete' ? 'scaleX(1)' : 'scaleX(0)',
          transformOrigin: 'left',
          transition: 'all 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)',
          borderRadius: '10px'
        }} />
      </div>
      
      {/* App Name */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '40px',
        overflow: 'hidden'
      }}>
        <span style={{
          fontSize: '32px',
          fontWeight: '700',
          opacity: animationStage === 'bridge' ? 1 : 
                   animationStage === 'complete' ? 1 : 0,
          transform: animationStage === 'bridge' ? 'translateY(0)' : 
                    animationStage === 'complete' ? 'translateY(0)' : 'translateY(20px)',
          transition: 'all 0.5s ease-out',
          color: 'white'
        }}>
          Mind
        </span>
        <span style={{
          fontSize: '32px',
          fontWeight: '700',
          color: '#f72585',
          marginLeft: '8px',
          opacity: animationStage === 'bridge' ? 1 : 
                   animationStage === 'complete' ? 1 : 0,
          transform: animationStage === 'bridge' ? 'translateY(0)' : 
                    animationStage === 'complete' ? 'translateY(0)' : 'translateY(20px)',
          transition: 'all 0.5s ease-out 0.1s'
        }}>
          Bridge
        </span>
      </div>
      
      {/* Tagline */}
      <div style={{
        marginTop: '16px',
        height: '24px',
        overflow: 'hidden'
      }}>
        <p style={{
          fontSize: '16px',
          opacity: animationStage === 'complete' ? 1 : 0,
          transform: animationStage === 'complete' ? 'translateY(0)' : 'translateY(10px)',
          transition: 'all 0.5s ease-out 0.2s',
          margin: 0,
          color: 'rgba(255, 255, 255, 0.9)'
        }}>
          Your mental wellness companion
        </p>
      </div>
      
      {/* Loading indicator */}
      <div style={{
        marginTop: '30px',
        opacity: animationStage === 'complete' ? 1 : 0,
        transition: 'opacity 0.3s ease-out 0.3s'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '3px solid rgba(255, 255, 255, 0.3)',
          borderTop: '3px solid white',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }} />
      </div>
    </div>
  );
}

export default SplashScreen;